

import Vue from 'vue';


export const state = () => ({
    search: { // 搜索条件
        province:"河北省",    //省份
        city:"石家庄市",   //城市
        centername:"",   //搜索内容
        activeName:'calculter'
    },
    data:{},    //搜索之后数据
    
});

export const mutations = {
    /**
     * 更新 搜索条件 中的 省份
     * @param {*} state 
     * @param {*} n 省份
     */
    updateProvince(state,n){
        state.search.province = n
    },
    /**
     * 更新 搜索条件 中的 城市
     * @param {*} state 
     * @param {*} n 城市
     */
    updateCity(state,n){
        state.search.city = n
    },
    /**
     * 更新 搜索条件 中的 搜索内容
     * @param {*} state 
     * @param {*} n 省份
     */
    updateCentername(state,n){
        state.search.centername = n
    },
       /**
     * 更新 搜索条件 中的 搜索内容
     * @param {*} state 
     * @param {*} n 省份
     */
        updateactiveName(state,n){
            state.search.activeName = n
        },
    /**
     * 更新 搜索之后数据 
     * @param {*} state 
     * @param {*} n 数据
     */
    updateData(state,n){
        state.data = n
    },
    
};

export const getters = {
    
};

export const actions = {
    
};